import { useContext, useState } from "react";
import { Helmet } from "react-helmet";

import Modal from "./Modal";

import { AuthContext } from "../contexts/AuthContext";
import RequestLeaveForm from "./RequestLeaveForm";
import ProjectAllocationForm from "./ProjectAllocationForm";
import ConfirmPrompt from "./ConfirmPrompt";
import AdminProjectTable from "./AdminProjectTable";
import AdminNotificationTable from "./AdminNotificationTable";
import AdminProjectView from "./AdminProjectView";
import SectionHeader from "./SectionHeader";

const AdminDashboard = () => {
  const { user } = useContext(AuthContext);

  const [selectedProject, setSelectedProject] = useState(null);

  const [isProjectViewOpen, setIsProjectViewOpen] = useState(false);
  const [isAllocationsViewOpen, setIsAllocationsViewOpen] = useState(false);
  const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] = useState(false);

  const handleProjectClicked = (project) => {
    setSelectedProject(project);
    setIsProjectViewOpen(true);
  }

  const deleteProject = (project) => {
    console.log('Deleting project:', project);
  }

  const [isRequestLeaveModalOpen, setIsRequestLeaveModalOpen] = useState(false);

  if (!user) return;

  return (
    <>
      <Helmet>
        <title>Dashboard | ASE Group</title>
      </Helmet>

      <div className="flex flex-col">
        <div className="flex flex-col md:flex-row md:justify-between gap-4 md:gap-[2%]">
          <div className="border-ase-blue border rounded-lg w-full md:w-[60%] h-fit flex-grow pb-1">
            <SectionHeader title="Active Projects" />

            <AdminProjectTable onProjectClicked={handleProjectClicked} />
          </div>

          <div className="border-ase-blue border rounded-lg w-full md:w-[40%] flex-grow pb-1 h-fit">
            <SectionHeader title="Notifications" />

            <AdminNotificationTable />
          </div>
        </div>
      </div>

      <Modal isOpen={isRequestLeaveModalOpen}>
        <RequestLeaveForm onCloseClicked={e => setIsRequestLeaveModalOpen(false)} />
      </Modal>

      <Modal isOpen={isProjectViewOpen}>
        <AdminProjectView
          project={selectedProject}
          onAddAllocationClicked={() => setIsAllocationsViewOpen(true)}
          onCloseClicked={() => setIsProjectViewOpen(false)}
        />
      </Modal>

      <Modal isOpen={isAllocationsViewOpen}>
        <ProjectAllocationForm
          project={selectedProject}
          onCloseClicked={() => setIsAllocationsViewOpen(false)}
        />
      </Modal>

      <Modal isOpen={isConfirmDeleteModalOpen}>
        <ConfirmPrompt
          message={`Are you sure you want to delete the ${selectedProject?.name} project?`}
          onConfirm={() => deleteProject(selectedProject)}
          onCancel={() => setIsConfirmDeleteModalOpen(null)}
        />
      </Modal>
    </>
  )
}

export default AdminDashboard;
